<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div class="text-center">
        <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
          Recuperar Senha
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          Digite o e-mail cadastrado para receber o link de recuperação
        </p>
      </div>
      
      <!-- Error Message -->
      <div v-if="error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
        {{ error }}
      </div>
      
      <!-- Success Message -->
      <div v-if="success" class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded">
        {{ success }}
      </div>
      
      <form v-if="!success" class="mt-8 space-y-6" @submit.prevent="handleSubmit">
        <div class="rounded-md shadow-sm">
          <div>
            <label for="email" class="sr-only">Email</label>
            <input
              id="email"
              v-model="email"
              name="email"
              type="email"
              required
              class="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm"
              placeholder="Email cadastrado"
            >
          </div>
        </div>
        
        <div>
          <button
            type="submit"
            :disabled="loading"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50"
          >
            <span v-if="loading">Enviando...</span>
            <span v-else>Enviar link de recuperação</span>
          </button>
        </div>
        
        <div class="text-center">
          <router-link to="/login" class="text-sm text-orange-600 hover:text-orange-500">
            Voltar para o login
          </router-link>
        </div>
      </form>
      
      <div v-else class="text-center">
        <router-link to="/login" class="text-sm text-orange-600 hover:text-orange-500">
          Voltar para o login
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { authApi } from '@/utils/api'

const email = ref('')
const loading = ref(false)
const error = ref('')
const success = ref('')

const handleSubmit = async () => {
  loading.value = true
  error.value = ''
  success.value = ''
  
  try {
    const response = await authApi.forgotPassword(email.value)
    success.value = response.data.message
  } catch (e: any) {
    error.value = e.response?.data?.detail || 'Erro ao solicitar recuperação de senha'
  } finally {
    loading.value = false
  }
}
</script>
